import { putChangePassword } from "../../Store/Action";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useThemeClass } from "@/Hooks/useThemeClass";
import { useTheme } from "styled-components";
import clsx from "clsx";

function Password() {
  const themeClass = useThemeClass();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    new_password: "",
    confirm_password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.new_password !== formData.confirm_password) {
      alert("오류: 비밀번호가 일치하지 않습니다!");
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await dispatch(putChangePassword(formData));
      if (response) {
        alert("성공: 비밀번호가 성공적으로 변경되었습니다!");
        window.location.reload();
      } else {
        throw new Error("비밀번호 변경에 실패했습니다.");
      }
    } catch (err) {
      setError(err.message || "오류가 발생했습니다.");
      alert(`오류: ${err.message || "비밀번호 변경에 실패했습니다."}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="flex flex-col gap-5 pt-4" onSubmit={handleSubmit}>
      <div className="flex flex-col gap-3">
        <p className="text-sm">비밀번호 </p>
        <input
          type="password"
          name="new_password"
          value={formData.new_password}
          onChange={handleChange}
          className={`${clsx(themeClass.bg("background"), themeClass.border("background"))} rounded-md w-full py-3 px-3`}
          placeholder="입력 비밀번호"
        />
      </div>
      <div className="flex flex-col gap-3">
        <p className="text-sm">비밀번호 재입력 </p>
        <input
          type="password"
          name="confirm_password"
          value={formData.confirm_password}
          onChange={handleChange}
          className={`${clsx(themeClass.bg("background"), themeClass.border("background"))} rounded-md w-full py-3 px-3`}
          placeholder="입력 비밀번호 재입력"
        />
      </div>
      {error && <p className="text-red-500 text-sm">오류: {error}</p>}
      <button
        type="submit"
        className={`${clsx(themeClass.bg("text"))} mt-5 py-3 text-white rounded-full text-sm`}
        disabled={loading}
      >
        {loading ? "수정 중..." : "수정하기"}
      </button>
    </form>
  );
}

export default Password;
